import { CircularProgress } from "@mui/material";
import { Suspense } from "react";
import styles from "./BasicSuspense.module.css"

const BasicSuspense = ({ children }) => <Suspense fallback={<div className={styles.progress}><CircularProgress /></div>}>{children}</Suspense>;

BasicSuspense.wrap = (element) => <BasicSuspense>{element}</BasicSuspense>;

export default BasicSuspense;
